import React from "react";

// Neutral "a board is loading" skeleton — column shapes with shimmering placeholder cards.
// Deliberately distinct from the setup/ghost canvas so opening an initialized board never
// flashes the uninitialized look during the brief config fetch.
const SKELETON_COLUMNS: number[] = [3, 2, 4, 2];

const BoardLoading: React.FC = () => {
  return (
    <div className="kuika-board__loading" aria-hidden="true">
      <div className="kuika-board__loading-columns">
        {SKELETON_COLUMNS.map((count: number, columnIndex: number) => (
          <div key={columnIndex} className="kuika-board__loading-col">
            <div className="kuika-board__loading-col-head" />
            {Array.from({ length: count }).map((_unused: unknown, cardIndex: number) => (
              <div key={cardIndex} className="kuika-board__card-skeleton" />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default BoardLoading;
